import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'typeface-raleway';
import 'typeface-roboto';
import App from './App';
import { AuthRedirect, isAuthRedirect } from './auth/auth-redirect';
import CustomerDisplay from './customer-display/customer-display';
import './i18n';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { initializeTracer } from './tracer';

// getting display info from URL
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const customerDisplay = !!urlParams.get('customerDisplay');

initializeTracer();

// creates a second entry point into the app
// if the URL is for a customerDisplay we will mount that root component
if (customerDisplay) {
  ReactDOM.render(
    <Suspense fallback={null}>
      {' '}
      <CustomerDisplay />{' '}
    </Suspense>,
    document.getElementById('root'),
  );
} else if (isAuthRedirect()) {
  ReactDOM.render(<AuthRedirect />, document.getElementById('root'));
} else {
  ReactDOM.render(<App />, document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

//commented until Notifications or LaunchDarkly are being used
/* Notification.requestPermission(function(status) {
  XLRLogger.info({
    message: `Notification permission status: ${status}`,
    source: '/src/index.tsx',
  });
}); */
